<div class="center-wrapper" (click)=openBox() *ngIf="order">
	<div class="pedido-paso3">
	    <div class="box box-2">
	        <div class="main-box">
	            <div class="number-box">
	                <div class="box-container">
	                    <span class="number-container">{{box_name}}</span>
	                </div>
	            </div>
	            <p class="nombre-cliente truncate" [innerHTML]="order.client.nickname"></p>
	            <!-- <p class="nombre-cliente truncate">Nombre</p> -->
	            <div class="pedido">
	                {{products}}
	            </div>
	            
	        </div>
	        <div class="text-center">
	            <a class="btn btn-lg btn-touch">Open Box</a>
	        </div>
	    </div>
	</div>
</div>